import { useState } from "react";
import { api } from "../lib/api";
import { useMe } from "../lib/useMe";
import { useT, useLocale, apiLang } from "../lib/i18n";

export function VerifyBanner() {
  const { me } = useMe();
  const t = useT();
  const { locale } = useLocale();
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("lean_verify_dismissed") === "1");
  const [sent, setSent] = useState(false);
  if (hidden || !me || !me.email || me.email_verified) return null;
  return (
    <div className="mx-4 mt-2 flex items-center gap-2 rounded-xl bg-amber-500/15 px-3 py-2 text-sm">
      <span className="flex-1">{t("auth.verifyBanner")}</span>
      <button className="underline" disabled={sent}
        onClick={() => { void api.resendVerify(apiLang(locale)); setSent(true); }}>
        {sent ? t("auth.verifySent") : t("auth.verifyResend")}
      </button>
      <button aria-label={t("common.dismiss")}
        onClick={() => { sessionStorage.setItem("lean_verify_dismissed", "1"); setHidden(true); }}>×</button>
    </div>
  );
}
